import React from "react";
import { useParams } from "react-router-dom";
import useFetch from "../../hooks/useFetch";
import { useState } from "react";
import { apiPath } from "../../utility/Constant";
import { useEffect } from "react";
import GlobalForm from "../../components/globalForm/GlobalForm";
import { updateData } from "../../hooks/update";

function CSRFocusUniquePage() {
  const { CSRApi } = apiPath;
  const { id } = useParams();
  const [csrData, uloading] = useFetch(CSRApi, true);
  const [filteredData, setFilteredData] = useState({});

  useEffect(() => {
    const filtereddata = [...csrData]
      .filter((item) => item.slug === "focus")
      .filter((item) => item._id === id)[0];
    setFilteredData(filtereddata);
  }, [csrData]);

  const { focusTitle, focusDescription, _id } = filteredData ?? {};

  const data = [
    {
      elementType: "textField",
      label: "Focus Title",
      type: "text",
      name: "focusTitle",
      defaultValue: focusTitle,
      required: true,
    },
    {
      elementType: "textField",
      label: "Focus Description",
      type: "text",
      name: "focusDescription",
      defaultValue: focusDescription,
      required: true,
    },
  ];

  const update = (data) => {
    updateData(`${CSRApi}/${id}`, data, true);
  };

  return <div>{_id && <GlobalForm data={data} update={update} />}</div>;
}

export default CSRFocusUniquePage;
